const OrderDeliveryClientDiet = (json: IOrderDeliveryClientDiet): IOrderDeliveryClientDietModel => {
	const { diet_id, diet_type, friendly_id, ...rest } = json

	return {
		...rest,
		dietID: diet_id,
		dietType: diet_type,
		friendlyID: friendly_id,
	}
}

const OrderDeliveryBoxPackaging = (json: IOrderDeliveryBoxPackaging): IOrderDeliveryBoxPackagingModel => {
	const {
		box_type,
		package_guid,
		region_branch,
		region_forwarder,
		region_identifier,
		status_short,
		total_weight,
		visualisation_url,
		delivery_notes_consolidated,
		diet_name,
		diet_nickname,
		...rest
	} = json

	return {
		...rest,
		boxType: box_type,
		packageGuid: package_guid,
		regionBranch: region_branch,
		regionForwarder: region_forwarder,
		regionIdentifier: region_identifier,
		statusShort: status_short,
		totalWeight: total_weight,
		visualisationUrl: visualisation_url,
		deliveryNotesConsolidated: delivery_notes_consolidated,
		dietName: diet_name,
		dietNickname: diet_nickname,
	}
}

const OrderDeliveryAddress = (json: IOrderDeliveryAddress): IOrderDeliveryAddressModel => {
	const {
		apartment_number,
		building_number,
		building_type,
		courier_instructions,
		custom_name,
		delivery_from,
		delivery_place,
		delivery_until,
		entry_code,
		is_alternative_delivery_phone_number,
		is_assigned,
		...rest
	} = json

	return {
		...rest,
		apartmentNumber: apartment_number,
		buildingNumber: building_number,
		buildingType: building_type,
		courierInstructions: courier_instructions,
		customName: custom_name,
		deliveryFrom: delivery_from,
		deliveryPlace: delivery_place,
		deliveryUntil: delivery_until,
		entryCode: entry_code,
		isAlternativeDeliveryPhoneNumber: is_alternative_delivery_phone_number,
		isAssigned: is_assigned,
	}
}

export const OrderDelivery = (json: IOrderDelivery): IOrderDeliveryModel => {
	const {
		date,
		address,
		box_packagings,
		boxes_count,
		client_diet,
		delivered_at,
		package_guid,
		region_branch,
		region_forwarder,
		region_identifier,
		diet_name,
		diet_nickname,
		...rest
	} = json

	return {
		...rest,
		address: OrderDeliveryAddress(address),
		boxPackagings: box_packagings ? box_packagings.map(OrderDeliveryBoxPackaging) : [],
		boxesCount: boxes_count,
		clientDiet: OrderDeliveryClientDiet(client_diet),
		date: new Date(date),
		deliveredAt: delivered_at ? new Date(delivered_at) : null,
		packageGuid: package_guid,
		regionBranch: region_branch,
		regionForwarder: region_forwarder,
		regionIdentifier: region_identifier,
		dietName: diet_name,
		dietNickname: diet_nickname,
	}
}
